import { render, staticRenderFns } from "./ShopGoodsManage.vue?vue&type=template&id=c4b1d89c&scoped=true&"
import script from "./ShopGoodsManage.vue?vue&type=script&lang=js&"
export * from "./ShopGoodsManage.vue?vue&type=script&lang=js&"
import style0 from "./ShopGoodsManage.vue?vue&type=style&index=0&id=c4b1d89c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b1d89c",
  null
  
)

export default component.exports